import { RESCHEDULE_LOCK_HOURS } from '@bidetny/config';

// Renders byte-identical to the pre-T159 Terms of Service sentence: T159
// centralizes where the number is defined without changing legal wording.
// Any wording change to customer-facing legal text belongs to T135.
export const TERMS_RESCHEDULE_LOCK_COPY =
  `If an order is cancelled within ${RESCHEDULE_LOCK_HOURS} hours of the installation time, then we cannot refund the installation fee.`;
